(function () {
    'use strict';
    var controllerId = '4a_pcConvalida';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'pCorso', 'tMisuraCode', 'isSuper', fn_4a_pcConvalida]);

    function fn_4a_pcConvalida( $scope, $uibModalInstance, datacontext, pCorso, tMisuraCode, isSuper) {
        $scope.record = jQuery.extend({}, pCorso);
        $scope.tMisuraCode = tMisuraCode;
        $scope.isSuper = isSuper;
        $scope.gestioneAnomalie = false;

        $scope.change_iConvalida = function () {
            $scope.record.ConvalidaNote = '';

        };

        //valore di default se ancora � da convalidare di default nella modale imposto "ammissibile"
        if ($scope.record.iConvalida == 0)
            $scope.record.iConvalida = 3;

        $scope.ok = function (isValid) {
            if (isValid) {
               
                var result = updateItem($scope.record);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function updateItem(item) {
            return datacontext.pCorso_setConvalida(item).then(function (data) {
                return data;
            });
        }

    }
})();